var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { jsx, jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import Draggable from "react-draggable";
import styles from "./index.module";
import { LocalTranslation } from "../../../../constants/translations";
import Message from "@m4b-design/message";
import Button from "@m4b-design/button";
import useSessionReplayCore from "../../../../hooks/useSessionReplayCore";
import { MAX_RECORDING_TIME, SessionReplayEventButton, SessionReplayEventSection } from "../../../../constants";
import { RecordingStatus } from "../..";
import { saveSessionLink, sendLarkMessageToGroup } from "./service";
import { removeDebugModeUrlParams } from "../../../../utils/session-replay-debug-mode-portal";
import useExperiments from "../../../../hooks/useExperiments";
import useGeneralConfigs from "../../../../hooks/useGeneralConfigs";
const convertSecondsToMinutesAndSeconds = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds}`;
};
const DebugIndicator = (props) => {
  const { recordingStatus, setRecordingStatus, customIndicatorComponent: CustomIndicatorComponent } = props;
  const [secondsRecorded, setSecondsRecorded] = React.useState(0);
  const [isInitialiseLoading, setIsInitialiseLoading] = React.useState(false);
  const [isSaveRecordingLoading, setIsSaveRecordingLoading] = React.useState(false);
  const { record, stopRecording, recordingMetaInfo } = useSessionReplayCore();
  const { internalExperiments } = useExperiments();
  const { larkGroupId } = internalExperiments;
  const { userLang, userCountry, teaCollectEvent, uid, appId } = useGeneralConfigs();
  const timerInterval = React.useRef();
  const startTimer = () => {
    timerInterval.current = setInterval(() => {
      setSecondsRecorded((prev) => prev + 1);
    }, 1e3);
  };
  const stopTimer = () => {
    clearInterval(timerInterval.current);
  };
  const startRecording = () => __async(void 0, null, function* () {
    setIsInitialiseLoading(true);
    const recordingId = yield record();
    if (recordingId) {
      saveSessionLink({
        sessionId: recordingId,
        userId: uid,
        path: [window.location.pathname],
        countryCode: userCountry != null ? userCountry : "",
        errorType: "oncall",
        errorInfo: { larkGroupId: larkGroupId != null ? larkGroupId : "" },
        region: userCountry != null ? userCountry : "",
        byteIOAppId: appId
      });
      startTimer();
      setIsInitialiseLoading(false);
    }
  });
  useEffect(() => {
    teaCollectEvent == null ? void 0 : teaCollectEvent("section_show", { section: SessionReplayEventSection.ON_CALL_RECORDING_POPUP });
    startRecording();
  }, []);
  useEffect(() => {
    if (secondsRecorded === MAX_RECORDING_TIME) {
      handleSaveRecordingAndExitDebugMode();
    }
  }, [secondsRecorded]);
  const sendRecordingToGroupChat = (larkGroupId2) => __async(void 0, null, function* () {
    var _a;
    const recordingContext = window["recordingContext"];
    if (recordingContext) {
      const recordingLink = (_a = recordingContext == null ? void 0 : recordingContext.recording) == null ? void 0 : _a.id;
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      const params = {
        link: recordingLink,
        groupId: larkGroupId2
      };
      const res = yield sendLarkMessageToGroup(params);
      if (res.status === 200) {
        Message.success({
          content: LocalTranslation.ExitDebugModeSuccessMessage[userLang]
        });
      } else {
        Message.error({
          content: LocalTranslation.ExitDebugModeFailureMessage[userLang]
        });
      }
    }
  });
  const handleSaveRecordingAndExitDebugMode = () => __async(void 0, null, function* () {
    teaCollectEvent == null ? void 0 : teaCollectEvent("button_click", {
      click_for: SessionReplayEventButton.ON_CALL_FINISH_RECORDING
    });
    stopTimer();
    setIsSaveRecordingLoading(true);
    yield sendRecordingToGroupChat(larkGroupId != null ? larkGroupId : "");
    stopRecording();
    setIsSaveRecordingLoading(false);
    setRecordingStatus(RecordingStatus.STOPPED_RECORDING);
    removeDebugModeUrlParams();
  });
  const formattedSecondsRecorded = convertSecondsToMinutesAndSeconds(secondsRecorded);
  const indicatorTitle = isInitialiseLoading ? LocalTranslation.InitialisingDebugModeTitle[userLang] : LocalTranslation.DebugModeTitle[userLang];
  const indicatorMessageContent = isInitialiseLoading ? LocalTranslation.InitialisingRecording[userLang] : LocalTranslation.DebugModeDescription[userLang];
  const exitButtonText = LocalTranslation.ExitDebugModeButton[userLang];
  if (CustomIndicatorComponent) {
    return /* @__PURE__ */ jsx(
      CustomIndicatorComponent,
      {
        secondsRecorded: formattedSecondsRecorded,
        indicatorTitle,
        indicatorMessageContent,
        exitButtonText,
        onExit: handleSaveRecordingAndExitDebugMode,
        isInitialiseLoading,
        isSaveRecordingLoading
      }
    );
  }
  return /* @__PURE__ */ jsx(Draggable, { children: /* @__PURE__ */ jsxs("div", { className: styles.recordingBanner, children: [
    /* @__PURE__ */ jsxs("div", { className: styles.bannerTitle, children: [
      /* @__PURE__ */ jsxs("span", { children: [
        " ",
        indicatorTitle,
        " "
      ] }),
      /* @__PURE__ */ jsx("span", { className: styles.timer, children: formattedSecondsRecorded })
    ] }),
    (recordingMetaInfo == null ? void 0 : recordingMetaInfo.id) && /* @__PURE__ */ jsxs("div", { className: styles.debugId, children: [
      LocalTranslation.DebugIdTitle[userLang],
      ": ",
      recordingMetaInfo == null ? void 0 : recordingMetaInfo.id,
      " "
    ] }),
    /* @__PURE__ */ jsx("div", { className: styles.bannerDescription, children: indicatorMessageContent }),
    /* @__PURE__ */ jsx(
      Button,
      {
        type: "primary",
        onClick: () => {
          handleSaveRecordingAndExitDebugMode();
        },
        loading: isSaveRecordingLoading || isInitialiseLoading,
        style: { backgroundColor: "rgb(0, 153, 149)", color: "#fff", fontWeight: 500 },
        children: exitButtonText
      }
    )
  ] }) });
};
var debug_indicator_default = DebugIndicator;
export {
  DebugIndicator,
  debug_indicator_default as default
};
